<template>
    <div class="header">
        <div class="btn-group">
            <div class="main3 flex-col">
                <div class="group3">
                    <div class="box1">
                        <span class="info3">投递岗位：</span>
                        <span class="info4">{{ positionName1 }}</span>
                    </div>
                    <div class="box4 flex-col" @click="sendmail = true">
                        <div class="group4 flex-row justify-between">
                            <img class="label1" referrerpolicy="no-referrer"
                                src="./assets/img/mmail.png" />
                            <span class="word7">发送邮件</span>
                        </div>
                    </div>
                    <el-dialog :visible.sync="sendmail" top="15%" :modal-append-to-body="false" width="480px" center>
                        <div class="bd2sb flex-col">
                            <div class="box3sb flex-row justify-between">
                                <img class="pic1sb" referrerpolicy="no-referrer" src="./assets/img/mail.png" />
                                <div class="main1sb flex-col justify-between">
                                    <div class="mod1">
                                        <span class="info1">简历将发送至账号默认邮箱</span>
                                        <span class="info2">{{ email }}</span>
                                        <span class="info3">中</span>
                                    </div>
                                    <div class="mod3 flex-row justify-between">
                                        <button @click="sendmail = false" class="box1sb flex-col"><span
                                                class="word1">取消</span></button>
                                        <button @click="sendResumeEail()" class="box2 flex-col"><span
                                                class="txt1">确定</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>
                    <div @click="beInterview()" v-if="idx == 0" class="box3 flex-col"><span class="word6">邀请面试</span>
                    </div>
                    <div @click="nodeliver()" v-if="idx == 2" class="box3 flex-col"><span class="word6">标记为无意向</span>
                    </div>
                    <div @click="noIntention()" v-if="idx == 0" class="box2 flex-col"><span class="txt3">不合适</span>
                    </div>
                    <div @click="deliver()" v-if="idx == 2" style="background-color: #ffc033;" class="box2 flex-col">
                        <span class="txt3">恢复为待处理</span>
                    </div>
                    <div @click="deliver()" v-if="idx == 1" style="background-color: #ffc033;" class="box2 flex-col">
                        <span class="txt3">恢复为待处理</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="main4 flex-col" v-if="detail != {}">
            <div class="bd4 flex-col">
                <div class="main5 flex-row">
                    <span class="info5">{{ detail.name }}</span>
                    <img class="pic2" referrerpolicy="no-referrer" src="./assets/img/yihurencai.png" v-show="detail.talentCertSw"/>
                    <div class="box5">
                        <span class="word8">期望薪资：</span>
                        <span class="info6">{{ detail.salaryExpectation }}</span>
                    </div>
                    <div class="box6">
                        <span class="info7">求职状态：</span>
                        <span class="word9">{{ jobSeeking }}</span>
                    </div>
                </div>
                <div class="main6 flex-col">
                    <div class="wrap2 flex-row">
                        <span class="txt4">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</span>
                        <span class="info8">{{ detail.sex }}</span>
                        <span class="info9">手机号码:</span>
                        <span class="word10">{{ detail.tel }}</span>
                        <span class="word11">英语水平:</span>
                        <span class="info10">{{ detail.englishLevel }}</span>
                    </div>
                    <div class="wrap3 flex-row">
                        <span class="word12">年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;龄:</span>
                        <span class="info11">{{parseInt(new Date().getFullYear()) - parseInt(detail.birthday.substring(0, 4))}}岁</span>
                        <span class="word13">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱:</span>
                        <span class="word14">{{ detail.email }}</span>
                        <span class="txt5">家庭住址:</span>
                        <span class="info12">{{ detail.homeAddress }}</span>
                    </div>
                    <div class="wrap4 flex-row">
                        <span class="txt6">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历:</span>
                        <span class="word15">{{ detail.eduName }}</span>
                        <span class="info13">意向科室:</span>
                        <span class="info14">{{ detail.intentionJob }}</span>
                        <span class="info15">健康状况:</span>
                        <span class="txt7">{{ detail.healthStatus }}</span>
                    </div>
                    <div class="wrap5 flex-row">
                        <span class="txt8">工作经验:</span>
                        <span class="txt9">{{ workYear1 }}年</span>
                        <span class="info16">是否接受夜班:</span>
                        <span class="word16">{{ detail.nightShift == 1 ? '接受' : '不接受' }}</span>
                        <span class="info17">婚姻状况:</span>
                        <span class="word17">{{ detail.maritalStatus }}</span>
                    </div>
                </div>
                <div class="main7 flex-row">
                    <img src="./assets/img/SkillsLabel.png" />
                    <span class="word18">技能标签</span>
                </div>
                <div class="main8 flex-col" v-if="detail.skillList">
                    <div class="box7 flex-row justify-between">
                        <div class="section8">
                            <div class="section7 flex-col" v-for="(item, index) in detail.skillList" :key="index"
                                v-if="item.certStatus">
                                <div class="block1 flex-row justify-between">
                                    <img class="icon2" referrerpolicy="no-referrer"
                                        src="./assets/img/renzheng.png" />
                                    <span class="word19">{{ item.skill }}</span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="section8">
                            <div v-for="(item, index) in detail.skillList" :key="index" v-if="!item.certStatus"
                                class="outer5 flex-col"><span class="info18">{{ item.skill }}</span></div>
                        </div>
                    </div>
                </div>
                <div class="main9 flex-row justify-between">
                    <img src="./assets/img/work.png"/>
                    <span class="info20">工作经历</span>
                </div>
                <div class="main10 flex-row justify-between">
                    <div class="wrap6 flex-col" v-for="(item, index) in detail.workList" :key="index">
                        <div class="layer3 flex-row justify-between">
                            <div class="main11 flex-col"></div>
                            <span class="txt11">{{ item.workUnit }}</span>
                        </div>
                        <div class="layer4 flex-row">
                            <el-tooltip placement="top" effect="dark" :content="item.workPosition">
                            <span class="info21">{{ item.workPosition }}</span>
                            </el-tooltip>
                            <el-tooltip placement="top" effect="dark" :content="item.department">
                            <span class="word20">{{ item.department }}</span>
                            </el-tooltip>
                            <span class="word21">{{ item.workStart }}&nbsp;—&nbsp;{{ item.workEnd }}</span>
                        </div>
                    </div>
                </div>
                <div class="main12 flex-row justify-between">
                    <img src="./assets/img/education.png"/>
                    <span class="txt13">教育经历</span>
                </div>
                <div class="main13 flex-col" v-for="(item, index) in detail.studyList" :key="index">
                    <div class="group6 flex-row">
                        <div class="outer9 flex-col"></div>
                        <el-tooltip placement="top" effect="dark" :content="item.schoolName">
                            <span class="word23">{{ item.schoolName }}</span>
                        </el-tooltip>
                        <span class="info24">{{ item.edu }}</span>
                        <span class="txt14">{{ item.major }}</span>
                        <span class="info25">{{ item.studykStart }}&nbsp;—&nbsp;{{ item.studyEnd }}</span>
                    </div>
                </div>
                <div class="main14 flex-row justify-between">
                    <img src="./assets/img/Character.png" />
                    <span class="word24">我的性格</span>
                </div>
                <div class="main15 flex-col" v-if="detail">
                    <div class="main16 flex-row justify-between">
                        <div class="layer7 flex-col" v-for="item in detail.selfCharacter.split(',')" :key='item'><span
                                class="info26">{{ item }}</span></div>
                    </div>
                </div>
                <div class="main17 flex-row justify-between">
                    <img src="./assets/img/Describe.png" />
                    <span class="txt15">自我描述</span>
                </div>
                <div class="main20 flex-col">
                    <span class="paragraph1" v-html="detail.selfDomain"></span>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

export default {
    data() {
        return {
            userId1:this.$route.query.userId,
            positionName1:this.$route.query.positionName,
            workYear1:this.$route.query.workYear,
            recordId:this.$route.query.recordId,
            manageStatus:this.$route.query.manageStatus,
            detail: {},
            typelist: [
                { label: "在职急换工作", value: "jihuan" },
                { label: "随时可以入职", value: "suishi" },
                { label: "在职急换工作", value: "jihuan" },
                { label: "在职想看机会", value: "xiangkan" },
                { label: "暂时不寻求机会", value: "buxun" }
            ],
            jobSeeking: '',
            email: '',
            idx: 0,
            sendmail: false
        }
    },
    methods: {
        noIntention() {
            this.$confirm('此操作将候选人标注为不合适, 是否操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.candidateHandle('noIntention');
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        },
        deliver() {
            this.$confirm('此操作将候选人恢复为有意向, 是否操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.candidateHandle('deliver');
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        },
        nodeliver() {
            this.$confirm('此操作将候选人标记为无意向, 是否操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.candidateHandle('noIntention');
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        },
        beInterview() {
            this.$confirm('邀请该候选人进行面试, 是否操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.candidateHandle('beInterview');
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        },
        candidateHandle(manageStatus) {
            this.$apiFun.candidateHandle({ recordId: this.recordId, manageStatus: manageStatus }).then((data) => {
                if (data.code === 200) {
                    this.$message({ message: '操作成功', type: 'success' });
                    if (manageStatus == 'noIntention') { this.idx = 1 }
                    if (manageStatus == 'deliver') { this.idx = 0 }
                    if (manageStatus == 'beInterview') { this.idx = 2 }
                }
            })
        },
        sendResumeEail() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$apiFun.sendResumeEail({ positionName: this.positionName1, companyId: localStorage.getItem("id"), basicId: this.userId1 }).then((data) => {
                if (data.code === 200) {
                    loading.close();
                    this.sendmail = false;
                    this.$message({ message: '发送成功', type: 'success' });
                }
            })
        },
    },
    mounted() {
        this.$apiFun.getUnitInfo({
            id: localStorage.getItem("id"),
        }).then((data) => {
            if (data.code === 200) {
                this.email = data.data.email
            }
        })
        if (this.manageStatus == 'deliver') { this.idx = 0 }
        if (this.manageStatus == 'noIntention') { this.idx = 1 }
        if (this.manageStatus == 'beInterview') { this.idx = 2 }
        this.$apiFun.getUserDetail({
            id: this.userId1
        }).then((data) => {
            if (data.code === 200) {
                this.detail = data.data;
                this.typelist.filter((item) => {
                    if (item.value == data.data.jobSeekingCode) {
                        this.jobSeeking = item.label;
                    }
                })
            }
        })

        this.$apiFun.update({id: this.$route.query.upid}).then((data) => {if (data.code === 200) {}})
    },
}
</script>
<style scoped lang="less" src="./assets/data.less" />

<style lang="less" scoped>
.header {
    height: 100vh;
    overflow: auto;
    border: none;
    border-bottom: none;
    padding-bottom: 200px;

    .btn-group {
        width: calc(88% - 3px);
        height: 70px;
        background: #FFFFFF;
        border: 1px solid #F0F2F6;
        line-height: 70px;
        position: fixed;
        z-index: 999;
    }
}
.main4 .bd4 .main10{
    height: auto !important;
    margin-top: 0px !important;
    display: flex;
    flex-wrap: wrap;
}
.main4 .bd4 .main10 .wrap6{
    margin-top: 21px !important;
}
.main4 .bd4 .main10 .wrap6 .layer4 .info21{
    width: 100px !important;
    overflow: hidden;
    text-overflow: ellipsis;
}
.main4 .bd4 .main10 .wrap6 .layer4 .word21{
    margin-left: 50px !important;
}
.main4 .bd4 .main10 .wrap6 .layer4 .word20{
    width: 100px !important;
    overflow: hidden;
    text-overflow: ellipsis;
}
.main4 .bd4 .main8 .box7 .section8{
    width: 920px !important;
    height: auto !important;
    display: flex;
    flex-flow: wrap;
}
.main4 .bd4 .main8{
    height: auto !important;
}
.main4 {
    margin: 0 auto !important;
    margin-top: 100px !important;
    margin-bottom: 20px;
}

.box1 {
    margin-top: -14px !important;
}

.pic1 {
    width: 99px;
    height: 94px;
    margin-top: 53px;
}

.mailbox {
    width: 218px;
    height: 60px;
    overflow-wrap: break-word;
    text-align: center;
    font-size: 0;
}

.send {
    font-size: 18px;
    color: rgba(21, 21, 21, 1);
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.feed {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    color: rgba(21, 21, 21, 1);
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.address {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    color: rgba(62, 124, 255, 1);
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mod3 {
    width: 218px;
    height: 38px;
    margin-top: 44px;
}

.box {
    height: 38px;
    border-radius: 19px;
    background-color: rgba(255, 197, 69, 1);
    width: 100px;
}

.word1 {
    width: 24px;
    height: 22px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 22px;
    text-align: left;
    margin: 8px 0 0 38px;
}

.firm {
    height: 38px;
    border-radius: 19px;
    background-color: rgba(62, 124, 255, 1);
    width: 100px;
}

.confirm {
    width: 24px;
    height: 22px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 22px;
    text-align: left;
    margin: 8px 0 0 38px;
}
</style>


